module.exports = __webpack_public_path__ + "img/t2.d824c40e.png";